import { Dispatch, SetStateAction, useState } from 'react';
import { Button } from '../../../components/common/Button/Button';
import { CheckText } from '../../../components/common/CheckText';
import { Box, Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';
import { Icon, IconWarningMark } from '../../../styles/Icons';
import { WithdrawStepsEnum } from './types';
import { P1, P2 } from '../../../styles/FontStyles';
import { useAppSelector } from '../../../app/hooks';

import { ErrorToast } from '../../../components';
import { WithdrawWallet } from './WithdrawWallet';
import { PROJECT_NAME } from '../../../helpers/helperFunctions';

interface Step2Props {
  setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
  walletAddress: string | undefined;
  walletAddressSign: string;
  connectWallet: () => Promise<void>;
  isConnected: boolean;
  setWalletAddressSign: Dispatch<SetStateAction<string>>;
}

export const Step2 = ({
  setWithdrawStep,
  walletAddress,
  walletAddressSign,
  connectWallet,
  isConnected,
  setWalletAddressSign
}: Step2Props) => {
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [checkbox3, setCheckbox3] = useState(false);
  const [checkbox4, setCheckbox4] = useState(false);
  const [checkbox5, setCheckbox5] = useState(false);
  const [checkbox6, setCheckbox6] = useState(false);
  const [checkbox7, setCheckbox7] = useState(false);

  const showError = () => ErrorToast('Check all checkboxes');

  const { verificationStatus } = useAppSelector((state) => state.settings);

  const handleCalculate = () => {
    if (checkbox1 === false) return showError();
    if (checkbox2 === false) return showError();
    if (checkbox3 === false) return showError();
    if (checkbox4 === false) return showError();
    if (checkbox5 === false) return showError();
    if (checkbox6 === false) return showError();
    if (checkbox7 === false) return showError();
    if (!walletAddress) return showError();

    if (!verificationStatus) {
      setWithdrawStep(WithdrawStepsEnum.TWO_FA_FACTOR_REQUIRED);
    } else {
      setWithdrawStep(WithdrawStepsEnum.FINAL_STEP);
    }
  };

  return (
    <>
      <Box gray>
        <Flexed column center>
          <Flexed>
            <Icon mb='12'>
              <IconWarningMark color={color.colors.primary900} size='52' />
            </Icon>
          </Flexed>
        </Flexed>
        <P1 bold center mb='20'>
          STEP 1: SELECT YOUR CRYPTO WALLET
        </P1>
        <P2 bold center mb='20' color={color.colors.error500}>
          IMPORTANT!
        </P2>
        <P2 bold center mb='20'>
          CHOOSE A WALLET THAT SUPPORTS THE <br />
          ERC-721 NON-FUNGIBLE TOKEN STANDARD.
        </P2>
        <P2 bold center mb='20'>
          IF YOU CHOOSE A WALLET THAT DOES NOT SUPPORT THE ABOVE MENTIONED
          STANDARD, YOUR NFT WILL BE LOST FOREVER.
        </P2>
        <Flexed column center>
          {!isConnected ? (
            <Button w='200px' mr='12' onClick={connectWallet}>
              Connect Your Wallet
            </Button>
          ) : (
            <Flexed>
              <WithdrawWallet
                walletAddress={walletAddress}
                connectWallet={connectWallet}
                isButtonVisible={true}
                isConnected={isConnected}
                setWalletAddressSign={setWalletAddressSign}
              />
            </Flexed>
          )}
        </Flexed>
      </Box>
      <CheckText
        checked={checkbox1}
        onClick={() => setCheckbox1(!checkbox1)}
        text={
          'I have checked that the wallet I selected supports the ERC-721 NFT STANDARD.'
        }
      />
      <CheckText
        checked={checkbox2}
        onClick={() => setCheckbox2(!checkbox2)}
        text={
          'I declare that I am in full control of the wallet I selected for withdrawal of my Hub NFT.'
        }
      />
      <CheckText
        checked={checkbox3}
        onClick={() => setCheckbox3(!checkbox3)}
        text={
          'I take full responsibility of withdrawing the Hub NFT to the above selected wallet and declare that I fully understand the responsibility of handling my own wallet and the potential dangers of losing my Hub NFT.'
        }
      />
      <CheckText
        checked={checkbox4}
        onClick={() => setCheckbox4(!checkbox4)}
        text={`I understand I will keep my Personal Orders (PO) qualification for ranks in the ${PROJECT_NAME} compensation plan.`}
      />
      <CheckText
        checked={checkbox5}
        onClick={() => setCheckbox5(!checkbox5)}
        text={
          'I understand that my Hub NFT will no longer count towards Binary Weekly Cap.'
        }
      />
      <CheckText
        checked={checkbox6}
        onClick={() => setCheckbox6(!checkbox6)}
        text={
          'I understand that I will keep receiving all my rewards from the Hub NFT to the wallet I have selected above.'
        }
      />
      <CheckText
        checked={checkbox7}
        onClick={() => setCheckbox7(!checkbox7)}
        text={
          'I declare that Travelution Club and all its partners have done everything necessary to inform me of the benefits and dangers of handling my own Hub NFT by withdrawing it from my Back-Office.'
        }
      />

      <Button
        mt='20'
        onClick={handleCalculate}
        disabled={
          !checkbox1 ||
          !checkbox2 ||
          !checkbox3 ||
          !checkbox4 ||
          !checkbox5 ||
          !checkbox6 ||
          !checkbox7 ||
          !walletAddressSign ||
          !walletAddress
        }>
        Continue to final step
      </Button>
    </>
  );
};
